import React from "react";
import { BookOpenIcon, FileTextIcon, PlayIcon, UsersIcon, CodeIcon } from "./HelpCenterIcons";

const RESOURCES = [
  { label: "User Guide", badge: "PDF", icon: FileTextIcon, iconColor: "#eb1414" },
  { label: "Video Tutorials", badge: "Video", icon: PlayIcon, iconColor: "#eb1414" },
  { label: "Community Forum", badge: "Link", icon: UsersIcon, iconColor: "#eb1414" },
  { label: "API Documentation", badge: "Link", icon: CodeIcon, iconColor: "#eb1414" },
];

const HelpCenterResources = () => {
  return (
    <div className="v2-help-pg-card">
      <div className="v2-help-pg-card__header">
        <div className="v2-help-pg-card__icon-wrap" style={{ background: "#fef2f2" }}>
          <BookOpenIcon size={20} color="#eb1414" />
        </div>
        <div>
          <h3 className="v2-help-pg-card__title">Resources</h3>
          <p className="v2-help-pg-card__subtitle">
            Helpful guides and documentation
          </p>
        </div>
      </div>

      <div className="v2-help-pg-resources">
        {RESOURCES.map((res) => {
          const Icon = res.icon;
          return (
            <button className="v2-help-pg-resource" key={res.label}>
              <div className="v2-help-pg-resource__left">
                <Icon size={18} color={res.iconColor} />
                <span className="v2-help-pg-resource__label">{res.label}</span>
              </div>
              <span className="v2-help-pg-resource__badge">{res.badge}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default HelpCenterResources;
